import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/chat/empty-img-default.svg'
import _imports_1 from '@/assets/app/default_app.svg'


const _withScopeId = n => (_pushScopeId("data-v-a4374cb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screenTime" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "chart" }
const _hoisted_4 = { class: "chatTitle" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "time" }
const _hoisted_8 = { class: "appChart" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "empty" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "empty-text" }
const _hoisted_14 = { class: "appList" }
const _hoisted_15 = { class: "header" }
const _hoisted_16 = { class: "headerIcon" }
const _hoisted_17 = { class: "headerIcon" }
const _hoisted_18 = { class: "headerIcon" }
const _hoisted_19 = { class: "content" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "callItem" }
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  src: _imports_1,
  class: "app-img"
}
const _hoisted_24 = { class: "callItem" }
const _hoisted_25 = { class: "callItem" }
const _hoisted_26 = { class: "noMore" }
const _hoisted_27 = {
  key: 2,
  class: "empty"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_29 = { class: "empty-text" }

import { defineComponent, ref, onMounted, computed, watch } from "vue";
import publicHeader from '@/components/publicHeader/publicHeader.vue'
import loading from "@/components/chat/loading.vue";
import { ElMessage } from "element-plus";
import { dateFormat, formatSecondsToTime } from "@/utils/format";
import { getScreen } from "@/api/devices";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import * as echarts from 'echarts';
import { convertSecondsToHoursMinutes, convertSecondsToHoursMinutesSecond } from "@/views/screen/component/fomat";
import { gaEvent } from "@/utils/format";

import debounce from 'lodash/debounce';


export default /*#__PURE__*/_defineComponent({
  __name: 'screenTime',
  emits: ['updateHeaderDate'],
  setup(__props, { emit: Emits }) {

const store = useStore();
const { t } = useI18n();
const whichData = ref('chat.all')

const id = computed(() => {
  return store.state.currentDeviceId;
});
const isVibe = computed(() => !store.state.isVibe);
const currentLang = computed(() => store.state.currentLang)
const showTimeFront = ref(false)
let lastUpdateTime = ref(0)
const showUpdateTime = ref(false)
const globalLoading = ref(false)
// 定义网络请求的起始时间
let startTime = ref('')
let endTime = ref('')

const screenTime = ref(0)
const tableData = ref<any[]>([])
const isCloseLoading = ref(true)

onMounted(async () => {
  if (isVibe.value) {
    globalLoading.value = true
    tableData.value = []
    await getAppUsages()
    gaEvent("ScreenTime_PV", {
      event_category: "ScreenTime",
      event_label: tableData.value.length > 0 ? "Data" : "NoData",
    });
    drawChart()
  }
})


// 有的语言时间需要显示在前面
watch(currentLang, () => {
  if (currentLang.value == 'zh-CN' || currentLang.value == 'ja' || currentLang.value == 'ko' || currentLang.value == 'tr' || currentLang.value == 'zh-TW') {
    showTimeFront.value = true
  } else {
    showTimeFront.value = false
  }
}, {
  immediate: true
})

watch(id, async () => {
  globalLoading.value = true
  tableData.value = []
  await getAppUsages()
  gaEvent("ScreenTime_PV", {
    event_category: "ScreenTime",
    event_label: tableData.value.length > 0 ? "Data" : "NoData",
  });
  drawChart()
  if (!isVibe.value) {
    clearInterval(closeFiveM);
    setNewInterval()
  }
})

//删除弹窗的文案
const getDeleteInfo = () => {
  let info = t('famikeep200.Screen Usage Time for xxx')
  let temp = info.split('xxx')
  info = temp[0] + temp[1]
  console.log("temp:", temp, info);
  return info
}

const updateInfo = async () => {
  if (isVibe.value) {
    store.commit("setSyncLoading", false);
    ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    return
  }
  globalLoading.value = true
  tableData.value = []
  await getAppUsages(true)
  drawChart()
  clearInterval(closeFiveM);
  setNewInterval()
}

// 12小时定时更新
let closeFiveM: any
closeFiveM = setInterval(async () => {
  tableData.value = []
  globalLoading.value = true
  await getAppUsages()
  drawChart()
}, 1000 * 60 * 60 * 12);

// 设置新的定时器
const setNewInterval = () => {
  closeFiveM = setInterval(async () => {
    tableData.value = []
    globalLoading.value = true
    await getAppUsages()
    drawChart()
  }, 1000 * 60 * 60 * 12);
}
const isFirst = ref(true)
const updateHeaderDate = async (value: any, label: any) => {
  startTime.value = value[0] ? dateFormat(value[0], "YYYYMMDD") : ''
  endTime.value = value[1] ? dateFormat(value[1], "YYYYMMDD") : ''
  console.log('接收到的时间：', startTime.value, endTime.value, label);
  if (label) {
    whichData.value = label
  }
  tableData.value = []
  globalLoading.value = true
  await getAppUsages()
  if (isFirst.value) {
    gaEvent("ScreenTime_PV", {
      event_category: "ScreenTime",
      event_label: tableData.value.length > 0 ? "Data" : "NoData",
    });
    isFirst.value = false
  }
  if (label) {
    const currentRange = capitalizeFirstLetter(label.split(".")[1])
    console.log('currentRange', currentRange);
    // gaEvent("ScreenTime_Date", {
    //   event_category: "ScreenTime",
    //   event_label: currentRange,
    // });
  }
  if (tableData.value.length > 0) {
    drawChart()
  }
  clearInterval(closeFiveM);
  setNewInterval()
};

const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const getAppUsages = async (isFromSync: Boolean = false) => {
  try {
    let params = {}
    if (!isVibe.value) {
      params = {
        device_id: id.value,
        start_date: startTime.value ? startTime.value : '',
        end_date: endTime.value ? endTime.value : ''
      }
    } else {
      params = {
        device_id: id.value,
        start_date: 20220801,
        end_date: 20500801
      }
    }
    currTopList.value = []
    currTop.value = []
    const res = await getScreen(params)
    if (res.data.code == 200 && res.data.data && Object.keys(res.data.data).length > 0) {
      console.log("res.data.code == 200  && res.data.data:", res.data.code == 200 && res.data.data);

      tableData.value = res.data.data.app_usages ? res.data.data.app_usages : []
      screenTime.value = res.data.data.screen_usage_time ? res.data.data.screen_usage_time : 0

      if (res.data.data.app_usages) {
        console.log('tableData.value && tableData.value.length <= 6', tableData.value && tableData.value.length <= 6);

        if (tableData.value && tableData.value.length <= 6) {
          tableData.value.forEach((item: any) => {
            currTopList.value.push({ 'name': item.name, 'data': [item.usage_time] })
          })

        } else {
          let newArr = tableData.value.slice(0, 6)
          newArr.forEach((item: any) => {
            currTopList.value.push({ 'name': item.name, 'data': [item.usage_time] })
          })
        }

        console.log('currTopList', currTopList.value);


        currTopList.value.forEach((item: any) => {
          currTop.value.push(item.name)
        })
      }

      // console.log('----',tableData.value,screenTime.value);

      if (!isFromSync) {
        lastUpdateTime.value = res.data.data.update_time
        if (lastUpdateTime.value) {
          showUpdateTime.value = true
        } else {
          showUpdateTime.value = false
        }
      } else {
        gaEvent("ScreenTime_Sync", {
          event_category: "ScreenTime",
          event_label: "Success",
        });
        if (lastUpdateTime.value == res.data.data.update_time) {
          ElMessage({
            message: t("famikeep200['Synchronization successful, no new data']"),
            type: "success",
          });
        } else {
          ElMessage({
            message: t("chat.syncSuccessed"),
            type: "success",
          });
        }
        lastUpdateTime.value = res.data.data.update_time
        if (lastUpdateTime.value) {
          showUpdateTime.value = true
        } else {
          showUpdateTime.value = false
        }
      }

      setTimeout(() => {
        isCloseLoading.value = false
      }, 1000)
    } else {
      showUpdateTime.value = false
    }
  } catch (err) {
    globalLoading.value = false
    if (isFromSync) {
      gaEvent("ScreenTime_Sync", {
        event_category: "ScreenTime",
        event_label: "Fail",
      });
      ElMessage({
        message: t("chat.syncFailed"),
        type: "error",
      });
    }
  } finally {
    globalLoading.value = false
    setTimeout(() => {
      store.commit("setSyncLoading", false);
    }, 1000)
  }
}

// 当前排行靠前的屏幕使用时长列表
const currTopList = ref<any[]>([])
const currTop = ref<any[]>([])

const chartContainer = ref(null);
let chart: any
const drawChart = () => {
  console.log('drawdraw');
  if (chart) {
    chart.dispose();
  }
  chart = echarts.init(chartContainer.value);
  const chartData = {
    labels: [''],
    // datasets: [
    //   {
    //     name: 'A',
    //     data: [30], 
    //   },
    //   {
    //     name: 'B',
    //     data: [15], 
    //   },
    //   {
    //     name: 'C',
    //     data: [10], 
    //   },
    // ],
    datasets: currTopList.value,
    colors: ['#4080FF', '#F9CC45', '#F99057', '#FA7772', '#B2DA4D', '#4CD3CF'], // Replace with desired colors
  };

  const option = {
    tooltip: {
      formatter: (params: any) => {
        return convertSecondsToHoursMinutesSecond(params.data); // Assuming you have the convertSecondsToHoursMinutes function
      },
    },
    legend: {
      orient: 'horizontal',
      x: 'center',
      y: 'bottom',
      bottom: 40,
      itemWidth: 8, // 设置图例项的宽度
      itemHeight: 8, // 设置图例项的高度
      data: currTop.value,
    },
    xAxis: {
      show: false,
      axisLabel: {
        formatter: (value: any, index: any) => {
          return chartData.datasets[index].name; // 使用数据中的名称作为标签
        }
      }
    },
    yAxis: {
      type: 'category',
      avoidLabelOverlap: false,
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      data: chartData.labels,
    },
    series: chartData.datasets.map((dataset, index) => ({
      name: dataset.name,
      type: 'bar',
      stack: 'stack',
      orient: 'horizontal', // Horizontal bar chart
      data: dataset.data,
      itemStyle: {
        color: chartData.colors[index],
        // borderRadius: [10, 10, 0, 0],
      },
    })),
  };
  console.log('option', option);

  chart.setOption(option);
}

// 屏幕变化重新画一次图表
const debouncedResizeHandler = debounce(drawChart, 500);
window.addEventListener('resize', debouncedResizeHandler);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(publicHeader, {
      headerName: _ctx.$t('famikeep200.Screen usage time'),
      showUpdateTime: showUpdateTime.value,
      headerSyncDate: _unref(lastUpdateTime),
      headerSelectData: [],
      onUpdateHeaderDate: updateHeaderDate,
      onUpdateInfo: updateInfo,
      isSevenDay: true,
      isScreenTime: true
    }, null, 8, ["headerName", "showUpdateTime", "headerSyncDate"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (showTimeFront.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t(whichData.value)) + " " + _toDisplayString(getDeleteInfo()), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(getDeleteInfo()) + " " + _toDisplayString(_ctx.$t(whichData.value)), 1)),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(formatSecondsToTime)(screenTime.value)), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (tableData.value && tableData.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", {
                  ref_key: "chartContainer",
                  ref: chartContainer,
                  style: {"width":"100%","height":"150px"}
                }, null, 512)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
                ])
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("famikeep200.Name")), 1),
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("famikeep200.Frequency")), 1),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("famikeep200.Usage time")), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          (tableData.value && tableData.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "calllogsItem",
                    key: item.contactName
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      (item.logo_url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: item.logo_url,
                            class: "app-img"
                          }, null, 8, _hoisted_22))
                        : (_openBlock(), _createElementBlock("img", _hoisted_23)),
                      _createElementVNode("span", null, _toDisplayString(item.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(item.frequency), 1),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(formatSecondsToTime)(item.usage_time)), 1)
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("chat.noMoreText")), 1)
              ]))
            : (globalLoading.value)
              ? (_openBlock(), _createBlock(loading, {
                  key: 1,
                  class: "loading"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
                ]))
        ])
      ])
    ])
  ]))
}
}

})